import { ROLES, CONSTANTS } from 'config';
import { has, keyBy } from 'lodash';
import template from './tsz-pricing.html';
import './tsz-pricing.styl';

function controller($rootScope, $tszToast, $sce, AuthService,
  SubscriptionService, PlanService, PropertyService) {

  'ngInject';

  this.roles = ROLES;

  this.plans = {};

  this.monthly = true;

  this.showEnterpriseButton = () => !this.public && (this.activeSubscription.plan === 'ENTERPRISE');
  this.showProfessionalButton = () => !this.public && (this.activeSubscription.plan === 'PROFESSIONAL');

  this.showPurchaseButton = () => !this.public
    && !(this.activeSubscription && this.activeSubscription.plan);

  this.showCancelButton = () => !this.public && this.activeSubscription.status === 'COMPLETED'
    && this.activeSubscription.endDate && this.activeSubscription.monthly;

  this.setMonthly = (monthly) => {
    this.monthly = monthly;
  };

  this.activeSubscription = {};

  this.loadPlans = () => {
    PlanService.list()
    .then((result) => {
      this.plans = keyBy(result, 'code');
      console.log(JSON.stringify(this.plans));
    }).catch(() => {
      $tszToast.showError('Error al cargar la lista de planes');
    });
  };

  this.loadCompanySubscription = (companyId) => {
    SubscriptionService.get(companyId)
    .then((data) => {
      this.activeSubscription = data;
      if (has(data, 'monthly')) {
        this.monthly = data.monthly;
      }
    }).catch(() => {
      $tszToast.showError('Se ha producido un error al intentar cargar las suscripciones');
    });
  };

  this.subscribe = (plan) => {

    console.log(`subscribe: plan ${plan} ${this.companyId}`);

    SubscriptionService.create(this.companyId, plan, this.monthly)
    .then((data) => {
      document.getElementById('Ds_SignatureVersion').value = data.dsSignatureVersion;
      document.getElementById('Ds_MerchantParameters').value = data.dsMerchantParameters;
      document.getElementById('Ds_Signature').value = data.dsSignature;
      const redsysForm = document.getElementById('redsysForm');
      redsysForm.action = data.redsysUrl;
      redsysForm.submit();
    }).catch(() => {
      $tszToast.showError('Se ha producido un error al intentar crear la suscripción');
    });
  };

  this.save = ($form) => {
    if ($form.$valid) {
      $form.commit();
    }
  };

  this.cancelSubscription = () => {
    this.cancellingSubscription = true;
    SubscriptionService.cancel(this.companyId, this.activeSubscription.id)
    .then((data) => {
      this.activeSubscription = data;
      $tszToast.showSuccess('La suscripción ha sido cancelada satisfactoriamente');
    }).catch(() => {
      $tszToast.showError('Se ha producido un error al intentar cancelar la suscripción');
    }).finally(() => {
      this.cancellingSubscription = false;
    });
  };

  this.loadPromotionalMessage = () => {
    PropertyService.get(CONSTANTS.PROPERTY.PROMOTIONAL_MSG)
    .then((result) => {
      this.promotionalMessage = result.value;
    }).catch(() => {
      $tszToast.showError('Error al cargar la lista de planes');
    });
  };

  this.init = () => {
    this.loadPromotionalMessage();
    this.loadPlans();
    if (this.companyId) {
      this.loadCompanySubscription(this.companyId);
    }
  };

  this.init();

}

export default {
  template,
  bindings: {
    companyId: '<',
    public: '<',
  },
  controller,
};



// WEBPACK FOOTER //
// ./src/components/tsz-pricing/tsz-pricing.js